import { SVGProps } from "react"

const EmailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.33203 13.5H14.6654V3.5H1.33203V13.5Z"
      stroke="#898A93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33203 3.5L7.9987 8.5L14.6654 3.5"
      stroke="#898A93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.9987 3.5H1.33203V8.5"
      stroke="#898A93"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M14.6667 8.5V3.5H8" stroke="#898A93" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default EmailIcon
